import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ISymfonyUserRegistrationForm } from '../../../core/interfaces/interfaces';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { VasBaseObjectApiFacade } from '../base-object/vas-base-object.api-facade';
import { User } from './user.model';

export class UserApiFacade extends VasBaseObjectApiFacade<User> {

    get(id: string, options?: ApiRequestOptions): Observable<User> {
        return this.GET(`/users/${id}`, options)
            .map(object => new User(object));
    }

    getAll(options?: ApiRequestOptions): Observable<Array<User>> {
        return this.CGET(`/users`, options)
            .map(objects => objects.map(object => new User(object)));
    }

    register(values: ISymfonyUserRegistrationForm): Observable<Response> {
        return this.POST('/register', values);
    }

    updatePassword(user: User, password: string): Observable<Response> {

        const data = {
            user: {
                plainPassword: {
                    first: password,
                    second: password
                }
            }
        };

        return this.PATCH(`/users/${user.id}`, data);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.api-facade.ts